import React, { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { FiBookmark, FiSave, FiAlertCircle } from "react-icons/fi";
import useAxios from "../../hooks/useAxios";
import swal from "sweetalert";

const SavePlanVersionModal = ({
    show,
    onHide,
    planId,
    onSaved,
    currentCostCenterName,
    currentYear
}) => {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");

    const [{ loading: saving }, saveVersion] = useAxios(
        { url: `/plans/${planId}/versions`, method: "POST" },
        { manual: true, useCache: false }
    );

    const handleSubmit = async (e) => {
        e?.preventDefault?.();
        if (saving) return;

        try {
            const response = await saveVersion({
                data: {
                    name: name.trim() || undefined,
                    description: description.trim() || undefined
                }
            });

            swal({
                title: "¡Versión guardada!",
                text: response?.data?.message || "La versión de la planificación fue guardada exitosamente.",
                icon: "success",
                timer: 2000,
                buttons: false
            });

            setName("");
            setDescription("");
            onHide?.();
            onSaved?.();
        } catch (error) {
            swal({
                title: "Error al guardar",
                text: error?.response?.data?.message || "Ocurrió un error al guardar la versión.",
                icon: "error"
            });
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton style={{ borderBottom: '1px solid #e2e8f0' }}>
                    <Modal.Title className="d-flex align-items-center gap-2" style={{ fontSize: '1.05rem', fontWeight: 700, color: '#0f172a' }}>
                        <div style={{
                            width: 32,
                            height: 32,
                            borderRadius: 8,
                            background: '#eff6ff',
                            color: '#2563eb',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: 16
                        }}>
                            <FiBookmark />
                        </div>
                        Guardar Versión de Planificación
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="p-3">
                    {/* Notice box */}
                    <div style={{
                        background: '#f8fafc',
                        border: '1px solid #e2e8f0',
                        borderRadius: 8,
                        padding: '10px 12px',
                        fontSize: '0.8rem',
                        color: '#475569',
                        marginBottom: 14,
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 8
                    }}>
                        <FiAlertCircle className="text-primary mt-1 flex-shrink-0" style={{ fontSize: 15 }} />
                        <div>
                            Esta acción creará un <strong>respaldo completo e inmutable</strong> del estado actual de la planificación
                            {currentCostCenterName ? ` de ${currentCostCenterName}` : ''}{currentYear ? ` (${currentYear})` : ''},
                            incluyendo todas las cuentas, montos mensuales, dotación y totales calculados.
                        </div>
                    </div>

                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontSize: '0.82rem', fontWeight: 600, color: '#1e293b' }}>
                            Nombre de la versión <span className="text-muted fw-normal">(Opcional)</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Ej: Versión inicial / Ajuste dotación Q1"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            disabled={saving}
                            style={{ fontSize: '0.85rem' }}
                            maxLength={150}
                        />
                        <Form.Text className="text-muted" style={{ fontSize: '0.72rem' }}>
                            Si lo dejas en blanco se asignará automáticamente "Versión #".
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-1">
                        <Form.Label style={{ fontSize: '0.82rem', fontWeight: 600, color: '#1e293b' }}>
                            Notas o descripción <span className="text-muted fw-normal">(Opcional)</span>
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Ej: Cuentas ajustadas según reunión con gerencia..."
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            disabled={saving}
                            style={{ fontSize: '0.82rem', resize: 'none' }}
                            maxLength={500}
                        />
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer style={{ borderTop: '1px solid #e2e8f0', padding: '10px 16px' }}>
                    <Button
                        variant="light"
                        onClick={onHide}
                        disabled={saving}
                        size="sm"
                        style={{ fontWeight: 600, fontSize: '0.82rem' }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        variant="primary"
                        disabled={saving}
                        size="sm"
                        className="d-flex align-items-center gap-1"
                        style={{ fontWeight: 600, fontSize: '0.82rem', minWidth: 130, justifyContent: 'center' }}
                    >
                        {saving ? (
                            <>
                                <Spinner size="sm" animation="border" />
                                <span>Guardando...</span>
                            </>
                        ) : (
                            <>
                                <FiSave style={{ fontSize: 14 }} />
                                <span>Guardar versión</span>
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default SavePlanVersionModal;
